import { render } from "./phoneheadset.vue?vue&type=template&id=18fc3419&scoped=true"
import script from "./phoneheadset.vue?vue&type=script&lang=js"
export * from "./phoneheadset.vue?vue&type=script&lang=js"

import "./phoneheadset.vue?vue&type=style&index=0&id=18fc3419&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fc3419"]])

export default __exports__